"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = require("react");

var _AdapterMoment = _interopRequireDefault(require("@mui/lab/AdapterMoment"));

var _Form = require("../Form");

var _reactFinalForm = require("react-final-form");

var _TimePicker = require("../../TimePicker");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["name", "helperText", "readOnly", "disabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var moment = new _AdapterMoment.default().moment;

var FormTimePicker = function FormTimePicker(_ref) {
  var name = _ref.name,
      helperText = _ref.helperText,
      readOnly = _ref.readOnly,
      disabled = _ref.disabled,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var formProps = (0, _Form.useFormProps)(); // Custom callback will be used in dirty/pristine form state calculations.

  var isEqual = (0, _react.useCallback)(function (a, b) {
    // ensure all valid values are `moment` instances,
    // since `initialValue` will be `Sting` while TimePicker
    // will return `moment` value.
    var A = typeof a === "string" ? moment(a) : a;
    var B = typeof b === "string" ? moment(b) : b;
    return A instanceof moment && B instanceof moment && (A.isSame(B, "day") || B.isSame(A, "day")) || (A !== null && A !== void 0 ? A : null) === (B !== null && B !== void 0 ? B : null) // handle nullish and/or date values
    ;
  }, []); // react-final-form converts `undefined` to an empty string which causes
  // weird issues with the MaterialUI date picker and makes it uncontrolled in
  // some cases. Using the `format` function below prevents this from happening.
  // See: https://final-form.org/docs/react-final-form/types/FieldProps#format

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Field, {
    allowNull: true,
    format: function format(value) {
      return value;
    },
    isEqual: isEqual,
    name: name,
    children: function children(_ref2) {
      var input = _ref2.input,
          meta = _ref2.meta;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TimePicker.TimePicker, _objectSpread(_objectSpread(_objectSpread({
        margin: "normal"
      }, input), rest), {}, {
        disabled: disabled !== null && disabled !== void 0 ? disabled : formProps.disabled,
        error: meta.submitError && !meta.dirtySinceLastSubmit,
        helperText: meta.touched && meta.submitError && !meta.dirtySinceLastSubmit ? meta.submitError : helperText,
        readOnly: readOnly !== null && readOnly !== void 0 ? readOnly : formProps.readOnly
      }));
    }
  });
};

var _default = FormTimePicker;
exports.default = _default;